import { appKillSelf } from "@droid/android";
import { useTranslation } from "@fanfanlo";
import { Button } from "@mui/material";
import toast from "react-hot-toast";

export function KillSelf(){
    const {t} = useTranslation("homepage/components/app/kill-self/content")
    async function onClick(){
        toast.success(t("KillSelf.toast"))
        await new Promise(r=>setTimeout(r, 1000 * 1))
        appKillSelf()
    }
    return(
        <>
            <Button onClick={onClick}>
                {t("KillSelf.name")}
            </Button>
        </>
    )
}